"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSelect = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_select_1 = __importDefault(require("react-select"));
var throttle_debounce_1 = require("throttle-debounce");
/* Imported CSS */
require("./FileSelect.scss");
/* Blast Imports */
var FileList_1 = require("./FileList");
var FileSelectDropzone_1 = __importDefault(require("./FileSelectDropzone"));
var FilesizeLimitIndicator_1 = require("./FilesizeLimitIndicator");
var Toast_1 = require("@app/components/controls/Toast");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var RemoteSourceModal_1 = __importDefault(require("@app/features/transfers/components/upload/RemoteSourceModal"));
var actions_1 = require("@app/features/ui/state/actions");
var matomo_1 = require("@app/shared/matomo");
var initialState = {
    remoteSourceVisible: false,
    selectContainerWidth: 0,
    selectedSource: -1,
    selectedSourcePath: '',
    selectedSourceTitle: ''
};
var REF_SELECT_CONTAINER = 'select-container';
/**
 * File Select component, displays file contents for a package to be uploaded
 */
var FileSelect = /** @class */ (function (_super) {
    __extends(FileSelect, _super);
    function FileSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        _this.handleChangeSource = function (selectedOption) {
            _this.setState({
                remoteSourceVisible: false,
                selectedSource: selectedOption.value,
                selectedSourcePath: '/',
                selectedSourceTitle: selectedOption.label
            });
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Change Upload Source', selectedOption.label + " : " + selectedOption.value);
            _this.props.onOpenRemoteSource(selectedOption.value);
        };
        _this.handleCloseRemoteSourceModal = function () {
            _this.setState({ remoteSourceVisible: false });
        };
        _this.handleLoadMoreRemoteFiles = function (offset) {
            _this.props.onLoadMoreRemoteFiles(_this.state.selectedSource, offset, _this.state.selectedSourcePath);
        };
        _this.handleOpenRemoteSource = function (path) {
            _this.setState(__assign(__assign({}, _this.state), { remoteSourceVisible: true, selectedSourcePath: path }));
            _this.props.onOpenRemoteSource(_this.state.selectedSource, path);
        };
        _this.handleRemoteSelect = function (files) {
            _this.props.onSelect(files);
            _this.handleCloseRemoteSourceModal();
        };
        _this.handleWindowResize = function () {
            _this.setState(__assign(__assign({}, _this.state), { selectContainerWidth: _this.getContainerWidth() }));
        };
        _this.debouncedWindowResize = throttle_debounce_1.debounce(500, _this.handleWindowResize);
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    FileSelect.prototype.componentDidMount = function () {
        this.setState(__assign(__assign({}, this.state), { selectContainerWidth: this.getContainerWidth() }));
        window.addEventListener('resize', this.debouncedWindowResize);
    };
    FileSelect.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.debouncedWindowResize);
    };
    /* Component Lifecycle Methods - end */
    /* Component Methods - begin */
    FileSelect.prototype.getContainerWidth = function () {
        var container = react_dom_1.default.findDOMNode(this.refs[REF_SELECT_CONTAINER]);
        return (container.getBoundingClientRect().width);
    };
    /* Component Methods - end */
    FileSelect.prototype.render = function () {
        var _this = this;
        /* File Select constants */
        var sourceOptions = [{ value: -1, label: 'My Computer' }];
        this.props.remoteSourcesList.map(function (source) {
            sourceOptions.push({
                value: Number(source.id),
                label: source.name
            });
        });
        /* Action functions - begin */
        var getSelectedSource = function () {
            var selectedOption = null;
            sourceOptions.forEach(function (option) {
                if (option.value === _this.state.selectedSource) {
                    selectedOption = option;
                }
            });
            return selectedOption;
        };
        /* Action functions - end */
        return (react_1.default.createElement("div", { className: classnames_1.default('file-select-container', { empty: this.props.files.length === 0 }), ref: "select-container" },
            (this.props.remoteSourcesList.length !== 0) &&
                react_1.default.createElement("div", { className: "remote-sources" },
                    react_1.default.createElement("label", { className: "label" }, "Select File Source:"),
                    react_1.default.createElement(react_select_1.default, { className: "sources-list", value: getSelectedSource(), onChange: this.handleChangeSource, options: sourceOptions })),
            (this.state.selectedSource === -1) ? ((!this.props.isUploading) ?
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classnames_1.default('dropzone-container', { 'is-hidden': !this.props.pluginEnabled }) },
                        react_1.default.createElement(FileSelectDropzone_1.default, { className: 'dropzone', pluginEnabled: this.props.pluginEnabled, onSelect: this.props.onSelect })),
                    react_1.default.createElement("div", { className: classnames_1.default('dropzone-container', { 'is-hidden': (this.props.pluginEnabled || (!this.props.pluginEnabled && !this.props.httpGatewayStatus)) }) },
                        react_1.default.createElement(FileSelectDropzone_1.default, { className: 'gateway-select-dropzone', pluginEnabled: this.props.pluginEnabled, onSelect: this.props.onSelect })),
                    react_1.default.createElement("div", { className: classnames_1.default('dropzone-container', { 'is-hidden': this.props.pluginEnabled || this.props.httpGatewayStatus }) },
                        react_1.default.createElement(FileSelectDropzone_1.default, { className: 'file-select-dropzone', pluginEnabled: this.props.pluginEnabled, onSelect: this.props.onSelect })))
                : null) : (react_1.default.createElement("div", { className: "open-remote-button" },
                react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-yellow", onClick: function () { _this.handleOpenRemoteSource('/'); } }, "Open Remote Source"))),
            this.props.files.length > 0 &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(FilesizeLimitIndicator_1.FilesizeLimitIndicator, { currentSize: this.props.currentTotalSize, maxSize: this.props.maxTotalSize }),
                    react_1.default.createElement(Toast_1.Toast, { message: this.props.toasts[actions_1.ToastType.FILE_SELECT_ADDED_FILES], className: '', height: 26, position: 'top', width: this.state.selectContainerWidth },
                        react_1.default.createElement(FileList_1.FileList, { files: this.props.files, onRemove: this.props.onRemove }))),
            this.state.remoteSourceVisible &&
                react_1.default.createElement(RemoteSourceModal_1.default, { currentPath: this.state.selectedSourcePath, isLoadingRemoteFiles: this.props.isLoadingRemoteFiles, onClose: this.handleCloseRemoteSourceModal, onLoadMore: this.handleLoadMoreRemoteFiles, onOpen: this.handleOpenRemoteSource, onSelect: this.handleRemoteSelect, remoteFilesList: this.props.remoteFiles, sourceId: this.state.selectedSource, sourceTitle: this.state.selectedSourceTitle })));
    };
    return FileSelect;
}(react_1.Component));
exports.FileSelect = FileSelect;
var mapStateToProps = function (state) {
    return {
        httpGatewayStatus: state.transfers.httpGatewayStatus,
        toasts: state.ui.toasts
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(FileSelect);
